import React, { createContext, useState } from 'react';

export const ContentContext = createContext();

export const ContentContextProvider = (props) => {
	const [contentItem, setContentItem] = useState({});
	return <ContentContext.Provider value={[contentItem, setContentItem]}>{props.children}</ContentContext.Provider>;
};
